import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { PreorderContext } from "context/preorder-context";
import { useCallback, useContext } from "react";

export function usePreorderValidationNavigation() {
    const { nextInvalidGroup, setActiveTabIndex, activeTabIndex } =
        useContext(PreorderContext) || {};
    const { data: settings } = useExternalBookingSettings();

    return useCallback(() => {
        if (nextInvalidGroup?.index === undefined || !setActiveTabIndex) return;

        const menuInfoOffset = settings?.menuMessage ? 1 : 0;
        const uiIndex = nextInvalidGroup.index + menuInfoOffset;

        if (activeTabIndex === uiIndex) {
            setActiveTabIndex(-1);
            setTimeout(() => {
                setActiveTabIndex(uiIndex);
            }, 0);
        } else {
            setActiveTabIndex(uiIndex);
        }
    }, [activeTabIndex, nextInvalidGroup?.index, setActiveTabIndex, settings?.menuMessage]);
}
